export default "__VITE_ASSET__e1d6acde__"